import { primitiveColors } from './colors';
import { borderRadiusPrimitives } from './borderRadius';

export { primitiveColors } from './colors';
export { borderRadiusPrimitives } from './borderRadius';

/**
 * Combined primitive tokens
 * All primitive tokens should be exported here
 */
export const primitiveTokens = {
  ...primitiveColors,
  borderRadius: borderRadiusPrimitives,
};
